export default __webpack_public_path__ + "static/logo-de3f142b5b0afdeaf6160cb8321a88da.png";